export { Timeline } from "./Timeline";
export type { TimelineConfig, TimelineDataBasic } from "./types";
